import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CloseSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CloseSVG;
